export default "__VITE_ASSET__Dbtyc3bT__"